import { IncError } from "@core/domain/errors/inc.error";
import i18n from "@i18n";

export class ProceedingMapperError extends IncError {
    constructor() {
        super(i18n.t("error:entity.proceeding.proceedingMapperError"));

        Object.setPrototypeOf(this, ProceedingMapperError.prototype);
    }
}